const opportunities = [
  {
    num: "01",
    title: "Co-Hosted Educational Programs",
    desc: "Partner with Harambee to co-develop and deliver financial education programs for diaspora communities, emerging investors, and underserved audiences.",
    icon: "ri-book-open-line",
  },
  {
    num: "02",
    title: "Webinars &amp; Workshops",
    desc: "Collaborate on live and virtual events covering investor readiness, cross-border opportunity, wealth-building fundamentals, and strategic planning.",
    icon: "ri-video-chat-line",
  },
  {
    num: "03",
    title: "Strategic Outreach Initiatives",
    desc: "Join forces on targeted outreach campaigns that connect diaspora communities with credible education, advisory access, and long-term opportunity.",
    icon: "ri-megaphone-line",
  },
  {
    num: "04",
    title: "Investor-Readiness Programming",
    desc: "Support structured programs that help emerging investors build the knowledge, confidence, and frameworks needed to make informed long-term decisions.",
    icon: "ri-bar-chart-grouped-line",
  },
  {
    num: "05",
    title: "Cross-Border Advisory Collaboration",
    desc: "Work alongside Harambee&apos;s advisory team to expand access to structured guidance for diaspora professionals and families navigating cross-border opportunity.",
    icon: "ri-exchange-line",
  },
  {
    num: "06",
    title: "Workforce Development Initiatives",
    desc: "Partner on programs that build financial capability, professional readiness, and long-term economic participation within diaspora and local communities.",
    icon: "ri-tools-line",
  },
  {
    num: "07",
    title: "Community Engagement Partnerships",
    desc: "Engage directly with communities through Harambee&apos;s network &mdash; building trust, awareness, and access at the grassroots level.",
    icon: "ri-group-2-line",
  },
  {
    num: "08",
    title: "Ecosystem-Building Across Africa &amp; the Diaspora",
    desc: "Contribute to the long-term development of a connected, credible ecosystem spanning Nairobi, East Africa, and the global African Diaspora.",
    icon: "ri-earth-line",
  },
];

export default function PartnershipOpportunities() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-14 items-start">
          {/* Left sticky */}
          <div className="lg:col-span-2 lg:sticky lg:top-28">
            <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
              <span className="w-8 h-px bg-[#C9A961]" />
              Partnership Opportunities
            </span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
              How We Build Together
            </h2>
            <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
              Harambee offers a range of structured collaboration pathways designed to create meaningful, measurable impact for the communities we serve. Every opportunity is built around shared goals, mutual trust, and long-term value.
            </p>
            <img
              src="/assets/images/site/part-opp-001-600x500.jpg"
              alt="Harambee Global Ventures partnership opportunities collaboration"
              className="w-full h-[340px] object-cover object-top rounded-lg"
            />
          </div>

          {/* Right grid */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {opportunities.map((item) => (
              <div
                key={item.num}
                className="bg-[#F8F6F3] rounded-lg p-6 border border-[#E8E4DC] hover:border-[#C9A961]/40 transition-all duration-300 group"
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#C9A961]/50">
                    {item.num}
                  </span>
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 group-hover:bg-[#1A4D3C]/20 transition-colors">
                    <i className={`${item.icon} text-[#1A4D3C] text-sm`} />
                  </div>
                </div>
                <h3
                  className="font-semibold text-[#2B2D2F] text-sm mb-2 leading-snug"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
                <p
                  className="text-[#6B6B6B] text-xs leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: item.desc }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
